"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CyberTripsModule = /** @class */ (function () {
    function CyberTripsModule() {
    }
    return CyberTripsModule;
}());
exports.CyberTripsModule = CyberTripsModule;
